<script>
export default {
  name: 'BaseInputText',
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    id: {
      type: String,
      default: null,
      validator(value) {
        return /^[a-zA-Z][\w:.-]*$/.test(value)
      },
    },
    value: {
      type: [String, Number, Date],
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
      // Only allow types that essentially just render text boxes.
      validator(value) {
        return [
          'email',
          'number',
          'password',
          'search',
          'tel',
          'text',
          'url',
          'date',
        ].includes(value)
      },
    },
    rows: {
      type: Number,
      default: null,
    },
    vuelidate: {
      type: Object,
      default: () => {},
    },
    inputClass: {
      type: String,
      default: '',
    },
    required: Boolean,
    placeholder: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    component() {
      if (this.rows) return 'textarea'
      return 'input'
    },
    hasErrors() {
      return this.vuelidate && this.vuelidate.$error
    },
  },
  watch: {
    value: function(val) {
      this.value = val
      if (!this.rows) {
        this.$refs.inputRef.value = val
      }
    },
  },
  methods: {
    onInput({ target: { value } }) {
      this.$emit('update', value)
      this.vuelidate && this.vuelidate.$touch()
    },
  },
}
</script>

<template>
  <BaseFormGroup
    :id="id"
    :required="required"
    :label="label"
    :vuelidate="vuelidate"
    :has-errors="hasErrors"
  >
    <div class="relative">
      <component
        :is="component"
        :id="id"
        ref="inputRef"
        :class="[
          inputClass,
          { 'py-2': rows },
          hasErrors
            ? 'border-volunteer_red'
            : 'border-gray-light focus:border-gray',
        ]"
        :value="!rows && value"
        :name="id"
        :type="type"
        :rows="rows"
        class="border input"
        :placeholder="placeholder"
        v-bind="$attrs"
        @input="onInput"
        v-on="$listeners"
        >{{ rows && value }}</component
      >

      <span
        :class="{ 'opacity-100': hasErrors }"
        class="absolute top-0 right-0 flex items-center h-full pb-1 mx-4 transition-opacity duration-150 opacity-0 pointer-events-none text-volunteer_red"
      >
        <BaseIcon name="warning" />
      </span>
    </div>

    <template v-slot:errors>
      <slot name="errors" />
    </template>
  </BaseFormGroup>
</template>
